/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import moment from 'moment';

export default connectRequests((state, props) => {
  let url = `/maintenances/preview?locale=en&startTime=${moment()
    .subtract(1, 'month').startOf('month').format('YYYY-MM-DD')}`;
  const currentProduct = state.requests.products.value
    .find((p) => p.key === props.match.params.product) || { key: 'all' };
  if (currentProduct && currentProduct.key !== 'all') {
    url += ('&products=' + currentProduct.key);
  }

  return {
    maintenances: {
      url,
      onLoad: true,
      responseAlias: 'rows',
    },
  };
});

